import dayjs from 'dayjs'
import { ResidentMedication } from '../types'

export const getShowAlert = (medication: ResidentMedication): boolean => {
  const { stockAlertLevel, currentStockLevel, isBelowThreshold } = medication

  if (isBelowThreshold !== undefined) {
    return isBelowThreshold
  }

  if (currentStockLevel === undefined) return false

  return currentStockLevel <= (stockAlertLevel || 0)
}

export const getStockText = (
  props: { medication: ResidentMedication },
  t: (key: string) => string
): string | null => {
  const { medication } = props
  const { unit, currentStockLevel } = medication

  if (currentStockLevel === undefined) return null

  if (currentStockLevel === 0) return t('OUT_OF_STOCK')

  return `${currentStockLevel} ${unit ? `${unit} ` : ' '}${t('LEFT')}`
}

export const getSubLabel = (
  medication: ResidentMedication,
  t: (key: string) => string
): string | null => {
  const formattedTimestamp = medication.lastStockRecordDate
    ? dayjs(medication.lastStockRecordDate).format('DD-MM-YYYY • HH:mm')
    : null

  if (!formattedTimestamp) return null

  return `${t('UPDATED')} ${formattedTimestamp}`
}
